var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOurProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_780_337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6605 6.6681V5L17.2157 4.16595L16.1161 4.80086L11.445 2.10388V0.834052L10.0002 0L8.55536 0.834052V2.10388L3.88424 4.80086L2.78467 4.16595L1.33984 5V6.6681L2.43984 7.30302V12.697L1.33984 13.3319V15L2.78467 15.8341L3.88424 15.1991L8.55536 17.8957V19.1659L10.0002 20L11.445 19.1659V17.8961L16.1161 15.1991L17.2157 15.8341L18.6605 15V13.3319L17.5605 12.697V7.30302L18.6605 6.6681ZM16.8709 12.697L15.7713 13.3319V14.6017L11.1002 17.2987L10.0002 16.6638L8.90019 17.2987L4.22907 14.6017V13.3319L3.1295 12.697V7.30302L4.22907 6.6681V5.39828L8.90019 2.70129L10.0002 3.33621L11.1002 2.70129L15.7713 5.39828V6.6681L16.8709 7.30302V12.697Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6566 10.199L7.45703 8.92909V11.469L9.6566 12.7389V10.199ZM10.0014 9.60176L12.201 8.33185L10.0014 7.06189L7.80186 8.33185L10.0014 9.60176Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0014 4.81506C7.13779 4.81506 4.81641 7.13644 4.81641 9.99998C4.81641 12.8635 7.13779 15.1849 10.0014 15.1849C12.8649 15.1849 15.1863 12.8635 15.1863 9.99998C15.1863 7.13644 12.8649 4.81506 10.0014 4.81506ZM13.2354 11.6681C13.2354 11.7286 13.2195 11.7881 13.1892 11.8405C13.159 11.8929 13.1154 11.9364 13.063 11.9667L10.1738 13.6348C10.1214 13.6651 10.0619 13.681 10.0014 13.681C9.94083 13.681 9.88137 13.6651 9.82895 13.6348L6.93973 11.9667C6.8873 11.9364 6.84377 11.8929 6.8135 11.8405C6.78323 11.7881 6.7673 11.7286 6.76731 11.6681V8.33187C6.7673 8.27134 6.78323 8.21188 6.8135 8.15946C6.84377 8.10704 6.8873 8.06351 6.93973 8.03325L9.82895 6.36515C9.88137 6.33488 9.94083 6.31895 10.0014 6.31895C10.0619 6.31895 10.1214 6.33488 10.1738 6.36515L13.063 8.03325C13.1154 8.06351 13.159 8.10704 13.1892 8.15946C13.2195 8.21188 13.2354 8.27134 13.2354 8.33187V11.6681Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3438 10.1992V12.739L12.5433 11.4691V8.9292L10.3438 10.1992Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_780_337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurProducts);
export default __webpack_public_path__ + "static/media/our-products.4caf2a4853d8fc3e9a4f9019f755ccb3.svg";
export { ForwardRef as ReactComponent };